import * as AppState from '../../../../../../store/app.state';
import * as professorsSubmissionsActions from '../action/professors-submissions.actions';
import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';

/**
 * assignment reducer used to updated store values based on certain action.
 */

/**
 * State interface extends App state State and add user state to the main state.
 */
export interface State extends AppState.State {
   professorsSubmissions: professorsSubmissionsState;
}

/**
 * An SubjectState interface, which represents the blueprint of the User State.
 */
export interface professorsSubmissionsState {
   professorsSubmissions: any;
   submissionsNumber: number;
   errorMessage: string;
}

/**
 * SubjectState initial state.
 */
export const initialState: professorsSubmissionsState = {
   professorsSubmissions: null,
   submissionsNumber: null,
   errorMessage: null,
};

/**
 * Subject Reducer used to update the state upon Subject actions.
 */
export const professorsSubmissionsReducer = createReducer(
   initialState,
   /**
    * On loadSubjectsDetailsSuccess action updated current state with the following properties.
    */
   on(
      professorsSubmissionsActions.loadProfessorsSubmissionsStatisticsSuccess,
      (state, action): professorsSubmissionsState => {
         return {
            ...state,
            professorsSubmissions: action.data.data.submissions,
            submissionsNumber: action.data.data.submissionsNumber,
         };
      }
   ),

   /**
    * On loadSubjectsDetailsFailure action updated current state with the following properties.
    */
   on(
      professorsSubmissionsActions.loadProfessorsSubmissionsStatisticsFailure,
      (state, action): professorsSubmissionsState => {
         return {
            ...state,
            errorMessage: action.error,
         };
      }
   )
);
